/**
 * @generated SignedSource<<c381211d8f95e0bb460c1d58671db050>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WATaskSingleSettingsSelectRoutineQuery$variables = Record<PropertyKey, never>;
export type WATaskSingleSettingsSelectRoutineQuery$data = {
  readonly store: {
    readonly id: string;
    readonly publicTeams: ReadonlyArray<{
      readonly checklists: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"RoutineNavigationListItem_Routine">;
      }> | null;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ListSectionHeaderTeam_Team">;
    }>;
  };
};
export type WATaskSingleSettingsSelectRoutineQuery = {
  response: WATaskSingleSettingsSelectRoutineQuery$data;
  variables: WATaskSingleSettingsSelectRoutineQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WATaskSingleSettingsSelectRoutineQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ListSectionHeaderTeam_Team"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "checklists",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RoutineNavigationListItem_Routine"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WATaskSingleSettingsSelectRoutineQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "checklists",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "313ee4b4abdc5ea48b3bd2605f797325",
    "id": null,
    "metadata": {},
    "name": "WATaskSingleSettingsSelectRoutineQuery",
    "operationKind": "query",
    "text": "query WATaskSingleSettingsSelectRoutineQuery {\n  store {\n    id\n    publicTeams {\n      id\n      ...ListSectionHeaderTeam_Team\n      checklists {\n        id\n        ...RoutineNavigationListItem_Routine\n      }\n    }\n  }\n}\n\nfragment ListSectionHeaderTeam_Team on Team {\n  name\n  ...TeamIconCircleComponent_Team\n}\n\nfragment RoutineNavigationListItem_Routine on Routine {\n  title\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n"
  }
};
})();

(node as any).hash = "2a1b60bb7b0841960b6b041c33dd37cd";

export default node;
